/**
 * Claim the WRM data provided by the JIRA instance, utilises the wrm data cache where available.
 * <p>
 *
 * @param {string} key - WRM data key defined by JIRA or the JIRA plugin
 * @returns {*} data obtained from the WRM data set
 */
export const wrmClaimSafe = <TClaim,>(key: string): TClaim => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.wrmDataCache = window.wrmDataCache || {};

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (window.wrmDataCache[key]) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		return window.wrmDataCache[key];
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const data = window.WRM.data.claim(key);

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.wrmDataCache[key] = data;
	return data;
};

/**
 * Claim the WRM data provided by the JIRA instance.
 * <p>
 * Each data can only be claimed once so a second call will throw an exception.
 *
 * @param {string} key - WRM data key defined by JIRA or the JIRA plugin
 * @returns {*} data obtained from the WRM data set
 * @throws {Error} if there is no data for the given key
 */
export const wrmClaim = <TClaim,>(key: string): TClaim => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const claimedData = window.WRM.data.claim(key);

	if (claimedData === undefined) {
		throw new Error(`Could not find WRM data for key: ${key}`);
	}

	return claimedData;
};
